export default {
  loading(state) {
    return state.Loading;
  },
  reportList(state) {
    return state.Items;
  },
};
